import { SupportView } from './SupportView';
import { useSupport } from './Support.hooks';
import { Loading } from '@wfp/ui';

export const Support = () => {
  const { isHelpSectionsLoading, helpSections } = useSupport();

  if (isHelpSectionsLoading) {
    return <Loading />;
  }

  return <SupportView helpSections={helpSections} />;
};
